import React from "react";
import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { LayoutDashboard, Users, Award, Building2, Calendar, Newspaper, Settings, FileText, LogOut, ExternalLink, ShieldCheck } from "lucide-react";

const MENU = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/pendaftar", label: "Pendaftar", icon: FileText },
  { to: "/admin/skema", label: "Skema", icon: Award },
  { to: "/admin/asesor", label: "Asesor", icon: Users },
  { to: "/admin/tuk", label: "TUK", icon: Building2 },
  { to: "/admin/kegiatan", label: "Kegiatan", icon: Calendar },
  { to: "/admin/berita", label: "Berita", icon: Newspaper },
  { to: "/admin/sertifikat", label: "Sertifikat", icon: ShieldCheck },
  { to: "/admin/pengaturan", label: "Pengaturan", icon: Settings },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const doLogout = async () => { await logout(); nav("/admin/login"); };
  return (
    <div className="min-h-screen bg-slate-100 flex">
      <aside className="w-64 bg-emerald-950 text-white flex-shrink-0 hidden lg:flex flex-col">
        <div className="p-6 border-b border-emerald-900">
          <div className="font-display font-extrabold text-lg">LSP ADMIN</div>
          <div className="text-xs text-amber-300 mt-1">{user?.email}</div>
        </div>
        <nav className="flex-1 p-3 space-y-1">
          {MENU.map(m => (
            <NavLink key={m.to} to={m.to} end={m.end} className={({isActive}) => `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium ${isActive ? "bg-emerald-900 text-amber-300" : "text-white/75 hover:bg-emerald-900/60"}`}>
              <m.icon className="w-4 h-4" /> {m.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-3 border-t border-emerald-900 space-y-1">
          <Link to="/" target="_blank" className="flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm text-white/75 hover:bg-emerald-900/60"><ExternalLink className="w-4 h-4" /> Lihat Website</Link>
          <button onClick={doLogout} data-testid="admin-logout-btn" className="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm text-white/75 hover:bg-emerald-900/60"><LogOut className="w-4 h-4" /> Keluar</button>
        </div>
      </aside>
      <main className="flex-1 p-4 sm:p-6 lg:p-10 overflow-x-auto"><Outlet /></main>
    </div>
  );
}
